import { BundleProps } from 'utils/types';
import {
  StyledPriceBeforeSale,
  StyledProductImageContainer,
  StyledWhisperEmblemBadge,
  StyledWhispersBundle,
} from './style';
import { Box } from '@mui/system';
import { EBadgeType, EGradientDirection, EProductPriority } from 'utils/enums';
import WhispersBundlePrice from './BundlePrice';
import { useEffect, useState } from 'react';
import { WhisperSaleBadge } from 'components/Badge/Sale/WhisperSaleBadge';
import { BadgeData } from 'components/Badge/types';
import { WhispersOfferSection } from './Offer/Offer';
import { formattingNumber } from 'utils/index';

export const WhispersBundle: React.FC<BundleProps> = ({
  price,
  productList,
  backgroundSrc,
  bundleBorderColor = {
    colorOne: '#FFFBDB',
    colorTwo: '#FFD9AB',
    gradientDirection: EGradientDirection.TopToBottom,
  },
  backgroundColor = { colorOne: '#880000' },
  bundleButtonColor,
  badges = [],
  salePercentage = 0,
  isPreview = false,
}) => {
  const [mainProduct, setMainProduct] = useState<any>(null);
  const [emblemBadge, setEmblemBadge] = useState<any>(null);
  const [priceBeforeDiscount, setPriceBeforeDiscount] = useState('');

  useEffect(() => {
    if (Array.isArray(badges) && badges.length > 0) {
      const foundEmblem = badges?.find((b: BadgeData) => {
        return (
          b.badge?.type === EBadgeType.EMBLEM || b.type === EBadgeType.EMBLEM
        );
      });
      setEmblemBadge(foundEmblem?.badge?.emblem || foundEmblem?.emblem);
    } else {
      setEmblemBadge(null);
    }
  }, [badges]);

  useEffect(() => {
    if (!productList.length || productList.length === 0) return;
    setMainProduct(
      productList.find(
        (product) => product.priority === EProductPriority.MAIN,
      ) || productList[0],
    );
  }, [productList]);

  useEffect(() => {
    if (price.strokedPriceInCents) {
      const formattedPriceBeforeDiscount = formattingNumber(
        price?.strokedPriceInCents,
        price,
        price.isCents,
        price.multiplier,
        !isPreview,
      );
      setPriceBeforeDiscount(formattedPriceBeforeDiscount);
    }
  }, [price]);

  return (
    <StyledWhispersBundle
      backgroundSrc={backgroundSrc}
      backgroundColor={backgroundColor}
      bundleBorderColor={bundleBorderColor}
      className={'whispers-bundle'}
    >
      <Box className="container">
        {salePercentage > 0 && (
          <WhisperSaleBadge salePercentage={salePercentage} />
        )}
        {emblemBadge && (
          <StyledWhisperEmblemBadge>
            <img alt={'emblem-badge'} src={emblemBadge.imageUrl} />
          </StyledWhisperEmblemBadge>
        )}
        {mainProduct && (
          <StyledProductImageContainer>
            <img src={mainProduct.images.product} alt="product img" />
          </StyledProductImageContainer>
        )}
        <WhispersOfferSection
          quantityDisplay={mainProduct?.quantityDisplay}
          strokedSaleQuantity={mainProduct?.strokedSaleQuantity}
          images={mainProduct?.images}
        >
          <WhispersBundlePrice
            price={price}
            bundleButtonColor={bundleButtonColor}
          />
        </WhispersOfferSection>
        {priceBeforeDiscount && (
          <StyledPriceBeforeSale
            direction={price.symbolPosition === 'Right' ? 'rtl' : 'ltr'}
            gap={price.spacing ? '4px' : '0'}
          >
            <span>{price.currencySymbol}</span>
            <span className="actual-price">{priceBeforeDiscount}</span>
          </StyledPriceBeforeSale>
        )}
      </Box>
    </StyledWhispersBundle>
  );
};
